{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://ceo-os.local/schemas/v1/board-context-import.schema.json",
  "title": "BoardContextImport v1",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "schema_name",
    "schema_version",
    "contract_id",
    "produced_at",
    "producer",
    "payload_hash",
    "payload"
  ],
  "properties": {
    "schema_name": { "const": "board-context-import" },
    "schema_version": { "const": "1.0.0" },
    "contract_id": { "type": "string", "format": "uuid" },
    "produced_at": { "type": "string", "format": "date-time" },
    "producer": { "const": "digital-board" },
    "payload_hash": { "type": "string", "pattern": "^[a-f0-9]{64}$" },
    "payload": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "date",
        "current_180_day_mainline",
        "current_constraint",
        "today_business_battle",
        "current_maximum_risk",
        "no_start_list",
        "tomorrow_business_action"
      ],
      "properties": {
        "date": { "type": "string", "format": "date" },
        "current_180_day_mainline": { "type": "string", "minLength": 1 },
        "current_constraint": { "type": "string", "minLength": 1 },
        "today_business_battle": { "type": "string", "minLength": 1 },
        "current_maximum_risk": { "type": "string", "minLength": 1 },
        "no_start_list": {
          "type": "array",
          "items": { "type": "string", "minLength": 1 },
          "uniqueItems": true
        },
        "tomorrow_business_action": { "type": "string", "minLength": 1 }
      }
    }
  },
  "examples": [
    {
      "schema_name": "board-context-import",
      "schema_version": "1.0.0",
      "contract_id": "1107166e-5c24-4a39-b675-15685144ae56",
      "produced_at": "2026-07-26T08:00:00+08:00",
      "producer": "digital-board",
      "payload_hash": "5d0d472d11370a5179b76a44b93de5339b27455ab011f7de760beb895bd0ddfe",
      "payload": {
        "date": "2026-07-26",
        "current_180_day_mainline": "验证并销售高客单家庭服务的最小交付闭环。",
        "current_constraint": "付费客户访谈数量不足。",
        "today_business_battle": "完成 3 次目标客户深访。",
        "current_maximum_risk": "继续建设材料但没有付款验证。",
        "no_start_list": ["新内容栏目", "新软件项目"],
        "tomorrow_business_action": "跟进表达付费意愿的客户。"
      }
    }
  ]
}
